// 8 hand-tuned Duo IA characters generated via Gemini Nano Banana.
// Each file lives in /public/duo/{id}.jpg.
export const DUO_CHARACTERS = [
  { id: 'ayanna', name: 'Ayanna',  age: 24, vibe: 'Afro-pop',          img: '/duo/ayanna.jpg' },
  { id: 'yuki',   name: 'Yuki',    age: 22, vibe: 'K-pop',             img: '/duo/yuki.jpg'   },
  { id: 'amir',   name: 'Amir',    age: 26, vibe: 'Rap maghrébin',     img: '/duo/amir.jpg'   },
  { id: 'rohan',  name: 'Rohan',   age: 23, vibe: 'Bollywood',         img: '/duo/rohan.jpg'  },
  { id: 'lila',   name: 'Lila',    age: 20, vibe: 'Teen Pop métisse',  img: '/duo/lila.jpg'   },
  { id: 'felix',  name: 'Felix',   age: 19, vibe: 'Indie roux',        img: '/duo/felix.jpg'  },
  { id: 'marco',  name: 'Marco',   age: 27, vibe: 'Latino brun',       img: '/duo/marco.jpg'  },
  { id: 'noor',   name: 'Noor',    age: 65, vibe: 'Wise — vétérane',   img: '/duo/noor.jpg'   },
];
